module.exports = __webpack_public_path__ + "img/pcnoverview.0401a5ce.svg";